import { SplitHorizontalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const TimeLine = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <SplitHorizontalIcon {...rest} size={Sizes[size]} color={fill} />;
};

TimeLine.displayName = 'TimeLine';
